import { ConsentMapping, updateConsentMode } from "../seo/datalayer.consent"
import { CookieAccepted, CookieName } from "./cookiebar.types"

export function setCookie(cname: string, cvalue: string, exdays: number) {
    var d = new Date()
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
    var expires = 'expires=' + d.toUTCString()
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

export function getCookie(cname: string) {
    var name = cname + '='
    var ca = document.cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) == ' ') {
            c = c.substring(1)
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length)
        }
    }
    return ''
}

const cookieToModeMapping: ConsentMapping<CookieName> = { 
    'analytical-cookies': ['analytics_storage'], 
    'functional-cookies': ['functionality_storage'], 
    'video-cookies': [], 
    'tracking-cookies': ['personalization_storage', 'ad_personalization', 'ad_storage', 'security_storage'], 
} 

export const updateConsent = updateConsentMode(cookieToModeMapping) 

export const setConsentCookie = (cookie: CookieName, isAccepted: CookieAccepted) => { 
    updateConsent(cookie, isAccepted == 'yes') 
    setCookie(cookie, isAccepted, 1000) 
} 